import { Container, InlineText, LargeIcon } from './parts';

interface EmptyGalleryPlaceholderProps {
  description?: string;
}

export const EmptyGalleryPlaceholder = ({
  description = 'No images yet',
}: EmptyGalleryPlaceholderProps) => (
  <Container>
    <LargeIcon icon={'images'} />
    <InlineText>{description}</InlineText>
  </Container>
);

export default EmptyGalleryPlaceholder;
